import React from "react";

const ServicesSettings = ({ services, updateService, setServices }) => {
  return (
    <>
 
    <div className="bg-white p-6 rounded-2xl montserrat-font-1">
      {/* Header */}
      <h2 className="text-green-700 font-semibold text-lg mb-6">
        Activate/Deactivate Services
      </h2>

      {/* Cards */}
      <div className="grid md:grid-cols-2 gap-4 montserrat-font-1">
        {services.map((s) => (
          <div
            key={s.id}
            className="bg-gray-100 p-4 rounded-xl flex justify-between items-center shadow-sm"
          >
            {/* Service Name */}
            <span className="capitalize text-gray-700 font-medium">
              {s.orderType.replace("_", " ")}
            </span>

            {/* Toggle */}
            <button
              onClick={async () => {
                const newStatus = s.status === "Y" ? "N" : "Y";

                const res = await updateService(s.orderType, newStatus);

                if (res) {
                  setServices((prev) =>
                    prev.map((item) =>
                      item.orderType === s.orderType
                        ? { ...item, status: newStatus }
                        : item
                    )
                  );
                }
              }}
              className={`px-4 py-1.5 rounded-lg text-sm font-medium transition ${
                s.status === "Y"
                  ? "bg-red-500 hover:bg-red-600 text-white"
                  : "bg-green-600 hover:bg-green-700 text-white"
              }`}
            >
              {s.status === "Y" ? "Deactivate" : "Activate"}
            </button>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default ServicesSettings;